// extracted by mini-css-extract-plugin
export default {"btn":"ghost-button__btn___DRgY5","btn-selected":"ghost-button__btn-selected___12YL7","btn-unavailable":"ghost-button__btn-unavailable___2r2bu"};